import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=18dc1536"
import script from "./Payouts.vue?vue&type=script&lang=js"
export * from "./Payouts.vue?vue&type=script&lang=js"
import style0 from "./Payouts.vue?vue&type=style&index=0&id=18dc1536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports